/**
 * Optional text inputs submit `""` when left empty; the API expects `null`
 * for "not set", so trim and map blank to null.
 */
export const blankToNull = (value: string): string | null => {
  const trimmed = value.trim();
  return trimmed === "" ? null : trimmed;
};
